import { ItemWithId } from 'services/constants/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { EIconButtons } from 'services/constants/iconsTypes';

export const PPWR_PACKING_TYPE_ACTIONS = {
	EDIT_WEIGHT: 'Edit weight',
};

export type TPpwrPackingTypeTableRow = ItemWithId & {
	name: string;
	handler: string;
	examples: string;
	proofRequired: boolean;
	enabled: boolean;
	weight: string;
	weightProductPack: string;
	documentsCount: string;
	dashboardUpdatedAt: string | null;
	dashboardUpdatedBy: string;
};

export const tableStructure: TTableStructure<keyof TPpwrPackingTypeTableRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Packing Type',
		selector: 'name',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Handler',
		selector: 'handler',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Examples',
		selector: 'examples',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 2,
	},
	{
		name: 'Proof Required',
		selector: 'proofRequired',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Enabled',
		selector: 'enabled',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Weight, grams',
		selector: 'weight',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Product Pack Weight, grams',
		selector: 'weightProductPack',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Documents',
		selector: 'documentsCount',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Updated At',
		selector: 'dashboardUpdatedAt',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Updated By',
		selector: 'dashboardUpdatedBy',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: '',
		selector: 'actions' as keyof TPpwrPackingTypeTableRow,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		buttons: [
			{
				name: PPWR_PACKING_TYPE_ACTIONS.EDIT_WEIGHT,
				icon: EIconButtons.EDIT,
				tooltip: 'Edit weight',
			},
		],
	},
];
